// extracted by mini-css-extract-plugin
module.exports = {"testo":"markdown-module--testo--p5knm"};